import React from 'react';
import DownloadFile from './DownloadFile';

export default function LicentieOvereenkomst(props) {
    return (
        <DownloadFile filePath='/files/VM_Licentieovereenkomst.pdf' fileName='Licentieovereenkomst' />
    )
}